module.exports = __webpack_public_path__ + "static/media/open-source-x-lf-lockup.eca7495e.svg";